<template>
  <!-- PC端布局 -->
  <div class="pc-container" v-if="!isMobile">
    <div class="competition-container">
      <!-- 搜索区域 -->
      <div class="search-section">
        <el-form :model="listQuery" ref="queryForm" :inline="true" class="search-form">
          <el-form-item label="竞赛名称" prop="raceName">
            <el-input clearable placeholder="请输入竞赛名称搜索" v-model="listQuery.raceName" class="filter-item"
              @keyup.enter.native="handleFilter" style="width: 240px;">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
          </el-form-item>

          <!-- <el-form-item label="状态" prop="status">
            <el-select
              v-model="listQuery.status"
              placeholder="状态"
              clearable
              class="filter-item"
              style="width: 120px;"
            >
              <el-option label="正常" value="0" />
              <el-option label="停用" value="1" />
            </el-select>
          </el-form-item> -->

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 活动列表 -->
      <div class="competition-grid">
        <transition-group name="fade-transform" mode="out-in" tag="div">
          <div v-for="item in list" :key="item.id" class="competition-card" @click.stop="handleSignup(item)">
            <!-- 状态标签 -->
            <div class="status-tag" :class="getStatusClass(item.joinStatus)">
              {{ getStatusText(item.joinStatus) }}
            </div>

            <!-- 活动标题 -->
            <div class="card-header">
              <h3 class="competition-title">{{ item.raceName }}</h3>
              <div v-if="item.subtitle" class="competition-subtitle">
                {{ item.subtitle }}
              </div>
            </div>

            <!-- 活动信息 -->
            <div class="card-content">
              <!-- 报名分类 -->
              <div class="info-item">
                <i class="el-icon-s-flag"></i>
                <span>{{ getEntrySortText(item.entrySort) }}</span>
              </div>

              <!-- 人数限制 -->
              <div class="info-item">
                <i class="el-icon-user"></i>
                <span>
                  {{ item.numberCeiling === 0 || !item.numberCeiling ? '不限制人数' : `限${item.numberCeiling}人` }}
                </span>
              </div>

              <!-- 活动时间 -->
              <div class="info-item">
                <i class="el-icon-time"></i>
                <span>{{ formatTime(item.startTime, item.endTime) }}</span>
              </div>

              <!-- 价格 -->
              <div class="price-section">
                <span class="price" :class="{ 'free-price': item.price === 0 || item.price === '0' }">
                  {{ item.price === 0 || item.price === '0' ? '免费' : `¥${item.price}` }}
                </span>
              </div>

              <!-- 报名情况 -->
              <!-- <div class="signup-stats">
                <div class="stat-item">
                  <div class="stat-label">已报名</div>
                  <div class="stat-value signed">{{ item.ybmNum || 0 }}</div>
                </div>
                <div class="stat-item">
                  <div class="stat-label">待审核</div>
                  <div class="stat-value pending">{{ item.dshNum || 0 }}</div>
                </div>
                <div class="stat-item">
                  <div class="stat-label">已退回</div>
                  <div class="stat-value returned">{{ item.thNum || 0 }}</div>
                </div>
              </div> -->
            </div>

            <!-- 操作按钮 -->
            <div class="card-actions">
              <el-button type="primary" size="small" @click.stop="handleSignup(item)"
                >
                {{ getSignupButtonText(item) }}
              </el-button>
              <!-- <el-button
                type="default"
                size="small"
                @click.stop="handleViewDetail(item)"
              >
                查看详情
              </el-button> -->
            </div>
          </div>
        </transition-group>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && list.length === 0" class="empty-state">
        <i class="el-icon-data-analysis" style="font-size: 60px; color: #DCDFE6;"></i>
        <p class="empty-text">暂无活动</p>
      </div>

      <!-- 加载更多按钮 -->
      <div class="load-more-container" v-if="!isLastPage && list.length > 0">
        <el-button type="default" @click="loadMore" :loading="loading" :disabled="loading">
          {{ loading ? '加载中...' : '加载更多' }}
        </el-button>
      </div>

      <!-- 加载结束提示 -->
      <div v-if="isLastPage && list.length > 0" class="no-more-container">
        <p>没有更多了</p>
      </div>
    </div>
  </div>

  <!-- 移动端布局 -->
  <div class="mobile-container" v-else>
    <div class="mobile-header">
      <div class="header-title">活动列表</div>
    </div>

    <!-- 移动端搜索 -->
    <div class="mobile-search">
      <div class="search-input-wrapper">
        <i class="el-icon-search search-icon"></i>
        <input type="text" v-model="listQuery.raceName" placeholder="搜索竞赛名称" class="search-input"
          @keyup.enter="handleFilter" />
        <i v-if="listQuery.raceName" class="el-icon-close clear-icon"
          @click="listQuery.raceName = ''; handleFilter()"></i>
      </div>

      <!-- <div class="filter-buttons">
        <div
          class="filter-button"
          :class="{ active: listQuery.status === '' }"
          @click="handleStatusFilter('')"
        >
          全部
        </div>
        <div
          class="filter-button"
          :class="{ active: listQuery.status === '0' }"
          @click="handleStatusFilter('0')"
        >
          进行中
        </div>
        <div
          class="filter-button"
          :class="{ active: listQuery.status === '1' }"
          @click="handleStatusFilter('1')"
        >
          已结束
        </div>
      </div> -->
    </div>

    <!-- 移动端活动列表 -->
    <div class="mobile-list" v-if="!loading && list.length > 0">
      <transition-group name="van-fade" tag="div">
        <div v-for="item in list" :key="item.id" class="mobile-card" @click.stop="handleSignup(item)">
          <!-- 状态标签 -->
          <div class="mobile-status" :class="getStatusClass(item.joinStatus)">
            {{ getStatusText(item.joinStatus) }}
          </div>

          <!-- 活动标题 -->
          <div class="mobile-title">
            <h3>{{ item.raceName }}</h3>
            <div v-if="item.subtitle" class="mobile-subtitle">
              {{ item.subtitle }}
            </div>
          </div>

          <!-- 活动信息 -->
          <div class="mobile-info">
            <div class="info-row">
              <i class="el-icon-time"></i>
              <span>{{ formatTimeMobile(item.startTime, item.endTime) }}</span>
            </div>

            <div class="info-row">
              <i class="el-icon-s-flag"></i>
              <span>{{ getEntrySortText(item.entrySort) }}</span>
            </div>

            <div class="info-row">
              <i class="el-icon-user"></i>
              <span>
                {{ item.numberCeiling === 0 || !item.numberCeiling ? '人数不限' : `限${item.numberCeiling}人` }}
              </span>
            </div>
          </div>

          <!-- 底部信息 -->
          <div class="mobile-footer">
            <div class="price-section">
              <span class="mobile-price" :class="{ 'free-price': item.price === 0 || item.price === '0' }">
                {{ item.price === 0 || item.price === '0' ? '免费' : `¥${item.price}` }}
              </span>
            </div>

            <div class="signup-count">
              <span class="count-text">{{ item.ybmNum || 0 }}人已报名</span>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="mobile-actions">
            <van-button type="primary" size="small" @click.stop="handleSignup(item)"
               class="signup-button" block>
              {{ getSignupButtonText(item) }}
            </van-button>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- 移动端空状态 -->
    <div v-else-if="!loading && list.length === 0" class="mobile-empty">
      <van-empty image="search" description="暂无活动" />
      <p class="empty-tip">换个搜索词试试~</p>
    </div>

    <!-- 移动端加载更多 -->
    <div class="mobile-load-more" v-if="!isLastPage && list.length > 0">
      <van-button type="default" @click="loadMore" :loading="loading" :disabled="loading" block>
        {{ loading ? '加载中...' : '加载更多' }}
      </van-button>
    </div>

    <!-- 移动端加载结束 -->
    <div v-if="isLastPage && list.length > 0" class="mobile-no-more">
      <p>没有更多了</p>
    </div>

    <!-- 移动端加载状态 -->
    <div v-if="loading && list.length === 0" class="mobile-loading">
      <van-loading type="spinner" color="#1989fa" />
      <p>加载中...</p>
    </div>
  </div>
</template>

<script>
import { fetchList } from '@/api/activity/index'
import { parseTime } from '@/utils/wyg'
import { Empty, Loading, Button } from 'vant'
import { pushWithTitle } from '@/utils/route'

export default {
  name: 'ActivityListPage',
  components: {
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Button.name]: Button
  },
  data() {
    return {
      isMobile: false,
      list: [],
      total: 0,
      loading: true,
      isLastPage: false,
      listQuery: {
        raceName: '',
        entrySort: this.$route.query.type || '',
        // status: '',
        pageNum: 1,
        pageSize: 8, // PC端默认8条
        // sort: 'id',
        // order: 'descending'
      }
    }
  },
  created() {
    this.listQuery.entrySort = this.$route.query.type
    this.checkDevice()
    this.getList()
  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛报名'
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 检查设备类型
    checkDevice() {
      const width = window.innerWidth
      this.isMobile = width <= 768
      // 如果是移动端，调整每页显示数量
      if (this.isMobile) {
        this.listQuery.pageSize = 10
      }
    },

    handleResize() {
      this.checkDevice()
    },

    // 获取活动列表
    getList() {
      this.loading = true
      fetchList(this.listQuery).then(response => {
        const { total, rows } = response
        this.total = total
        this.isLastPage = total < (this.listQuery.pageNum * this.listQuery.pageSize)

        // 直接设置列表数据
        this.list = rows || []
        this.loading = false
      }).catch(error => {
        console.error('获取活动列表失败:', error)
        this.loading = false
        this.$message.error('获取活动列表失败')
      })
    },

    // 加载更多
    loadMore() {
      if (this.isLastPage || this.loading) {
        return
      }

      this.loading = true
      setTimeout(() => {
        this.listQuery.pageNum++
        fetchList(this.listQuery).then(response => {
          const { total, rows } = response
          this.total = total
          this.isLastPage = total < (this.listQuery.pageNum * this.listQuery.pageSize)

          // 追加新数据
          this.list = [...this.list, ...(rows || [])]
          this.loading = false
        }).catch(error => {
          console.error('加载更多失败:', error)
          this.loading = false
          this.$message.error('加载更多失败')
        })
      }, 300)
    },

    // 搜索
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },

    // 重置搜索
    resetQuery() {
      this.listQuery = {
        raceName: '',
        entrySort: '',
        status: '',
        pageNum: 1,
        pageSize: this.isMobile ? 10 : 8,
        sort: 'id',
        order: 'descending'
      }
      this.getList()
    },

    // 移动端状态筛选
    handleStatusFilter(status) {
      this.listQuery.status = status
      this.listQuery.pageNum = 1
      this.getList()
    },

    // 获取状态样式
    getStatusClass(status) {
      return status === '3' ? 'status-normal' : 'status-disabled'
    },

    // 获取状态文本
    getStatusText(status) {
      return status === '0' ? '待审核' : status === '1' ? '已报名' : status === '2' ? '待修改' : '未参加'
    },

    // 获取报名分类文本
    getEntrySortText(entrySort) {
      const map = {
        '0': '社会成人',
        '1': '高校学生',

      }
      return map[entrySort] || '未知'
    },

    // 格式化时间
    formatTime(startTime, endTime) {
      if (!startTime || !endTime) return ''

      const start = parseTime(startTime, '{y}-{m}-{d}')
      const end = parseTime(endTime, '{y}-{m}-{d}')

      if (start === end) {
        return `${start}`
      }
      return `${start} ~ ${end}`
    },

    // 移动端格式化时间
    formatTimeMobile(startTime, endTime) {
      if (!startTime || !endTime) return ''

      const start = parseTime(startTime, '{m}/{d}')
      const end = parseTime(endTime, '{m}/{d}')

      if (start === end) {
        return `${start}`
      }
      return `${start}~${end}`
    },

    // 检查是否在报名时间内
    isInSignupTime(item) {
      if (item.status === '1') return false

      const now = new Date().getTime()
      const startTime = new Date(item.startTime).getTime()
      const endTime = new Date(item.endTime).getTime()

      return now >= startTime && now <= endTime
    },

    // 获取报名按钮文本
    getSignupButtonText(item) {
      if (item.status === '1') {
        return '已结束'
      }

      const now = new Date().getTime()
      const startTime = new Date(item.startTime).getTime()
      const endTime = new Date(item.endTime).getTime()

      if (now < startTime) {
        return '未开始'
      } else if (now > endTime) {
        return '已结束'
      } else {
        if (item.joinStatus !== "3") {
          return '已报名'
        }
        return '立即报名'
      }
    },

    // 卡片点击
    handleCardClick(item) {
      this.$router.push({
        name: 'activity-detail',
        query: { id: item.id }
      })
    },

    // 立即报名
    handleSignup(item) {
      /*if (item.status === '1' || !this.isInSignupTime(item)) {
        return
      }*/

      // 检查是否在报名时间内
      /*const now = new Date().getTime()
      const startTime = new Date(item.startTime).getTime()
      const endTime = new Date(item.endTime).getTime()

      if (now < startTime) {
        this.$message.warning('活动还未开始报名')
        return
      }

      if (now > endTime) {
        this.$message.warning('活动已结束报名')
        return
      }*/

      // 跳转到报名页面
      pushWithTitle({
        name: 'signup-details',
        query: {
          id: item.id,
          joinStatus: item.joinStatus,
          raceName: item.raceName
        }
      }, '网络学院')
    },

    // 查看详情
    handleViewDetail(item) {
      this.$router.push({
        name: 'activity-detail',
        query: { id: item.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 动画效果 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}

.fade-transform-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-transform-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-transform-leave {
  opacity: 1;
  transform: translateY(0);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* PC端样式 */
.pc-container {
  min-height: 100vh;
  background: #f5f7fa;

  .competition-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;

    .search-section {
      background: white;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .search-form {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;

        .el-form-item {
          margin-bottom: 0;
        }
      }
    }

    .competition-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 20px;
      margin-bottom: 20px;

      .competition-card {
        background: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .status-tag {
          position: absolute;
          top: 10px;
          right: 10px;
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;

          &.status-normal {
            background: rgba(103, 194, 58, 0.1);
            color: #67c23a;
          }

          &.status-disabled {
            background: rgba(245, 108, 108, 0.1);
            color: #f56c6c;
          }
        }

        .card-header {
          padding: 20px 20px 0;

          .competition-title {
            margin: 0 0 8px 0;
            font-size: 18px;
            font-weight: 600;
            color: #303133;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .competition-subtitle {
            font-size: 14px;
            color: #909399;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .card-content {
          padding: 20px;

          .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            color: #606266;
            font-size: 14px;

            i {
              margin-right: 8px;
              color: #909399;
              min-width: 16px;
            }
          }

          .price-section {
            margin: 15px 0;
            padding-bottom: 15px;
            border-bottom: 1px solid #ebeef5;

            .price {
              font-size: 20px;
              font-weight: 600;
              color: #e6a23c;

              &.free-price {
                color: #67c23a;
              }
            }
          }

          .signup-stats {
            display: flex;
            justify-content: space-between;
            padding: 15px 0;
            border-top: 1px solid #ebeef5;

            .stat-item {
              text-align: center;
              flex: 1;

              .stat-label {
                font-size: 12px;
                color: #909399;
                margin-bottom: 4px;
              }

              .stat-value {
                font-size: 18px;
                font-weight: 600;

                &.signed {
                  color: #67c23a;
                }

                &.pending {
                  color: #e6a23c;
                }

                &.returned {
                  color: #409eff;
                }
              }
            }
          }
        }

        .card-actions {
          padding: 0 20px 20px;
          display: flex;
          gap: 10px;

          .el-button {
            flex: 1;
          }
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .empty-text {
        margin-top: 20px;
        color: #909399;
        font-size: 16px;
      }
    }

    .load-more-container {
      text-align: center;
      margin: 20px 0;
      padding: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .el-button {
        width: 200px;
      }
    }

    .no-more-container {
      text-align: center;
      padding: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      p {
        color: #909399;
        font-size: 14px;
      }
    }
  }
}

/* 移动端样式 */
.mobile-container {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 20px;

  .mobile-header {
    background: white;
    padding: 15px 20px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;

    .header-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .mobile-search {
    background: white;
    padding: 15px;
    margin-bottom: 10px;

    .search-input-wrapper {
      position: relative;
      margin-bottom: 15px;

      .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #c0c4cc;
      }

      .search-input {
        width: 60%;
        height: 40px;
        padding: 0 40px 0 40px;
        border: 1px solid #dcdfe6;
        border-radius: 20px;
        font-size: 14px;
        outline: none;

        &:focus {
          border-color: #409eff;
        }
      }

      .clear-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #c0c4cc;
        cursor: pointer;
      }
    }

    .filter-buttons {
      display: flex;
      gap: 10px;

      .filter-button {
        flex: 1;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #f5f7fa;
        border-radius: 15px;
        font-size: 13px;
        color: #606266;
        cursor: pointer;

        &.active {
          background: #409eff;
          color: white;
        }
      }
    }
  }

  .mobile-list {
    padding: 0 15px;

    .mobile-card {
      background: white;
      border-radius: 8px;
      padding: 15px;
      margin-bottom: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      position: relative;

      .mobile-status {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 500;

        &.status-normal {
          background: rgba(103, 194, 58, 0.1);
          color: #67c23a;
        }

        &.status-disabled {
          background: rgba(245, 108, 108, 0.1);
          color: #f56c6c;
        }
      }

      .mobile-title {
        margin-bottom: 10px;
        padding-right: 60px;

        h3 {
          margin: 0 0 5px 0;
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .mobile-subtitle {
          font-size: 13px;
          color: #909399;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .mobile-info {
        margin-bottom: 15px;

        .info-row {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          font-size: 13px;
          color: #606266;

          i {
            margin-right: 8px;
            color: #909399;
            font-size: 14px;
            min-width: 16px;
          }
        }
      }

      .mobile-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        border-top: 1px solid #ebeef5;

        .price-section {
          .mobile-price {
            font-size: 18px;
            font-weight: 600;
            color: #e6a23c;

            &.free-price {
              color: #67c23a;
            }
          }
        }

        .signup-count {
          .count-text {
            font-size: 12px;
            color: #909399;
          }
        }
      }

      .mobile-actions {
        margin-top: 15px;

        .signup-button {
          width: 100%;
        }
      }
    }
  }

  .mobile-empty {
    padding: 40px 20px;
    text-align: center;

    .empty-tip {
      margin-top: 10px;
      color: #c0c4cc;
      font-size: 14px;
    }
  }

  .mobile-load-more {
    padding: 15px;
    text-align: center;
  }

  .mobile-no-more {
    text-align: center;
    padding: 20px;
    color: #909399;
    font-size: 14px;
  }

  .mobile-loading {
    text-align: center;
    padding: 40px 20px;

    p {
      margin-top: 15px;
      color: #909399;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .pc-container {
    display: none;
  }
}

@media (min-width: 769px) {
  .mobile-container {
    display: none;
  }
}
</style>
